import { del, get, post, put } from "../api_helper"
import { getApiConfig } from "../authHelper"

const RENEWAL_REMINDERS = "/renewal-reminders"

const dateRangePayload = ({ startDate, endDate }) => startDate && endDate ? { startDate, endDate } : {}

export const getRenewalList = ({ startDate, endDate }) => {
  const range = dateRangePayload({ startDate, endDate })
  const query = new URLSearchParams(range).toString()
  return get(query ? `${RENEWAL_REMINDERS}?${query}` : RENEWAL_REMINDERS, getApiConfig())
}

export const getRenewalStats = () => get(`${RENEWAL_REMINDERS}/stats`, getApiConfig())

export const sendRenewalReminder = ({ userId, startDate, endDate }) => post(
  `${RENEWAL_REMINDERS}/${userId}/send`, dateRangePayload({ startDate, endDate }), getApiConfig()
)

export const sendAllRenewalReminders = ({ startDate, endDate }) => post(
  `${RENEWAL_REMINDERS}/send-all`, dateRangePayload({ startDate, endDate }), getApiConfig()
)

export const generateRenewalPaymentQr = ({ userId, ...body }) => post(
  `${RENEWAL_REMINDERS}/${userId}/payment-qr/generate`, body, getApiConfig()
)

export const sendRenewalPaymentQr = ({ userId, ...body }) => post(
  `${RENEWAL_REMINDERS}/${userId}/payment-qr/send`,
  body,
  { ...getApiConfig(), suppressErrorToast: true }
)

export const getRenewalReminderTemplates = () => get(`${RENEWAL_REMINDERS}/templates`, getApiConfig())

export const createRenewalReminderTemplate = data => post(`${RENEWAL_REMINDERS}/templates`, data, getApiConfig())

export const updateRenewalReminderTemplate = (id, data) => put(`${RENEWAL_REMINDERS}/templates/${id}`, data, getApiConfig())

export const updateRenewalReminderSupportNumber = supportNumber => put(
  `${RENEWAL_REMINDERS}/templates/support-number`, { supportNumber }, getApiConfig()
)

export const activateRenewalReminderTemplate = id => put(`${RENEWAL_REMINDERS}/templates/${id}/activate`, {}, getApiConfig())

export const deleteRenewalReminderTemplate = id => del(`${RENEWAL_REMINDERS}/templates/${id}`, getApiConfig())
